export const Colors = {
  primary: '#A20000',
  secondary: '#00a2a2',
  success: '#00A200',
  warning: '#f7ab48',
  danger: '#A20000',
  light: '#c8c8c8',
  lighter: '#f1f1f1',
  dark: '#333645',
  darker: '#6C6C6C',
  info: '#00a2a2',
  authorized: '#3498db',
  rejected: '#A20000',
  draft: '#A20000',
  generated: '#f7ab48',
  white: '#ffffff',
  roadmapIconColor: '#8b0100',

  complementary: '#00a2a2',
  analogous1: '#a20051',
  analogous2: '#a25100',
  triadic1: '#a2a200',
  triadic2: '#00a200',

  'Primary': {
    '50': '#fde8ea',
    '100': '#fac7c9',
    '200': '#e5908c',
    '300': '#d66660',
    '400': '#dc4439',
    '500': '#dc3219',
    '600': '#cf271a',
    '700': '#be1c16',
    '800': '#b1130e',
    '900': '#a20000'
  },
  'Complementary': {
    '50': '#dff1f3',
    '100': '#b0dddf',
    '200': '#7bc8ca',
    '300': '#42b2b3',
    '400': '#00a2a2',
    '500': '#009290',
    '600': '#008582',
    '700': '#007571',
    '800': '#006561',
    '900': '#004944'
  },
  'Analogous - 1': {
    '50': '#fae3eb',
    '100': '#f4b8ce',
    '200': '#ed8aad',
    '300': '#e75b8d',
    '400': '#e13675',
    '500': '#dd025d',
    '600': '#cc025a',
    '700': '#b70255',
    '800': '#a20051',
    '900': '#7d0049'
  },
  'Analogous - 2': {
    '50': '#f8eae6',
    '100': '#f5d0b9',
    '200': '#eeb38c',
    '300': '#e8975d',
    '400': '#e38437',
    '500': '#de7305',
    '600': '#d46d01',
    '700': '#c76500',
    '800': '#ba5e00',
    '900': '#a25100'
  },
  'Triadic - 1': {
    '50': '#fafce6',
    '100': '#f2f6c0',
    '200': '#e9f197',
    '300': '#dfeb6c',
    '400': '#d7e64a',
    '500': '#d0e21f',
    '600': '#c4d018',
    '700': '#b3b90c',
    '800': '#a2a200',
    '900': '#877b00'
  },
  'Triadic - 2': {
    '50': '#e6f6e4',
    '100': '#c3e7be',
    '200': '#9bd893',
    '300': '#6fc966',
    '400': '#4abd41',
    '500': '#17b10f',
    '600': '#00a200',
    '700': '#009000',
    '800': '#007f00',
    '900': '#006100'
  }
};
